import React from 'react';
import { Box, Inline, Stack, Text, xcss } from '@atlaskit/primitives';

export interface CardListItem {
	title: string;
	description: string;
	afterIcon?: React.ReactNode;
	href: string;
}

export const CardList = ({ children }: { children: React.ReactNode }) => (
	<Box role="list" xcss={wrapperStyles}>
		{children}
	</Box>
);

export const CardListItem = ({ title, description, href, afterIcon }: CardListItem) => (
	<Box role="listitem" xcss={listStyles}>
		<Box as="a" href={href} target="_blank" xcss={linkStyles}>
			<Inline alignBlock="center" spread="space-between">
				<Stack>
					<Text size="medium">{title}</Text>
					<Text size="small" color="color.text.subtlest">
						{description}
					</Text>
				</Stack>
				<Box xcss={afterIconStyles}>{afterIcon}</Box>
			</Inline>
		</Box>
	</Box>
);

const afterIconStyles = xcss({
	flexShrink: 0,
});

const wrapperStyles = xcss({
	border: '1px solid',
	borderColor: 'color.border',
	borderRadius: 'border.radius.200',
	overflow: 'hidden',
	width: '100%',
});

const listStyles = xcss({
	cursor: 'pointer',
	listStyleType: 'none',
	borderBottom: '1px solid',
	backgroundColor: 'elevation.surface',
	borderBottomColor: 'color.border',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	':last-child': {
		borderBottom: '0',
	},
});

const linkStyles = xcss({
	display: 'block',
	padding: 'space.150',

	':hover': {
		backgroundColor: 'elevation.surface.hovered',
	},

	':focus-within': {
		outline: 'none',
		backgroundColor: 'elevation.surface.hovered',
	},

	':active': {
		backgroundColor: 'elevation.surface.pressed',
	},
});
